import * as React from 'react';

import { Button, cn, Col } from '@rematter/ui-web';
import { LucidePlusCircle } from 'lucide-react';

export interface LineItemTableProps {
  children: React.ReactNode;
  isEmpty?: boolean;
  onAdd?: () => void;
  addButtonLabel?: string;
  hideAddButton?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  emptyTitle?: string;
  emptyDescription?: string;
}

export const LineItemTable: React.FC<LineItemTableProps> = ({
  children,
  isEmpty = false,
  onAdd,
  addButtonLabel,
  hideAddButton = false,
  disabled = false,
  isLoading = false,
  className,
  emptyTitle,
  emptyDescription,
}) => {
  const showAddButton = !hideAddButton && !disabled && onAdd;

  if (isEmpty) {
    return (
      <div className={cn('@LineItemTable', className)}>
        <Col gap5 className="py-8 text-center">
          <Col gap1>
            {emptyTitle && <p className="text-lg">{emptyTitle}</p>}
            {!disabled && emptyDescription && (
              <p className="text-sm text-neutral/50">{emptyDescription}</p>
            )}
          </Col>
          {showAddButton && (
            <div className="flex justify-center">
              <Button
                variant="outline"
                color="neutral"
                onPress={onAdd}
                size="large"
                icon={<LucidePlusCircle />}
              >
                {addButtonLabel}
              </Button>
            </div>
          )}
        </Col>
      </div>
    );
  }

  return (
    <div className={cn('@LineItemTable flex flex-col gap-2', className)}>
      {children}
      {showAddButton && !isLoading && (
        <div className="mt-3">
          <Button
            variant="outline"
            color="neutral"
            onPress={onAdd}
            isDisabled={disabled}
          >
            <LucidePlusCircle className="size-4" />
            {addButtonLabel}
          </Button>
        </div>
      )}
    </div>
  );
};
